<template>
  <div class="knd-modal-overlay" @click="hide" v-show="show">
    <div class="knd-modal">

      <div class="knd-modal-container">
      <slot></slot>
      <div class="close" @click="hide">
        <!-- <img class="close-img" src="~/assets/close-icon.svg" alt="" /> -->
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 21.5625C5.94264 21.5625 1.4375 17.0574 1.4375 11.5C1.4375 5.94264 5.94264 1.4375 11.5 1.4375C17.0574 1.4375 21.5625 5.94264 21.5625 11.5C21.5625 17.0574 17.0574 21.5625 11.5 21.5625ZM11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z" fill="#4E243F"/>
        <path d="M6.67927 6.67927C6.95996 6.39858 7.41504 6.39858 7.69573 6.67927L11.5 10.4835L15.3043 6.67927C15.585 6.39858 16.04 6.39858 16.3207 6.67927C16.6014 6.95996 16.6014 7.41504 16.3207 7.69573L12.5165 11.5L16.3207 15.3043C16.6014 15.585 16.6014 16.04 16.3207 16.3207C16.04 16.6014 15.585 16.6014 15.3043 16.3207L11.5 12.5165L7.69573 16.3207C7.41504 16.6014 6.95996 16.6014 6.67927 16.3207C6.39858 16.04 6.39858 15.585 6.67927 15.3043L10.4835 11.5L6.67927 7.69573C6.39858 7.41504 6.39858 6.95996 6.67927 6.67927Z" fill="#4E243F"/>
        </svg>
        
      </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
			hideFn:Function,
      show: Boolean
		},
    watch: {
      show: function (newValue, oldValue) {
       if(newValue) {
        let el = document.getElementById('knd-app');
        el.style.overflowY = 'scroll';
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'inherit';
        let el = document.getElementById('knd-app');
        el.style.overflowY = 'inherit';
       }
      },
    },
    methods: {
			hide() {
				this.hideFn();
			}
    }

}
</script>

<style lang="scss">

.knd-modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: baseline;
  background-color: rgb(0 0 0 / 20%);
  z-index: 100;
}

.knd-modal {
  margin-top: 2em;
  text-align: left;
  background-color: #D0FFEB;
  min-width: 350px;
  max-width: 550px;
 
  border-radius: 20px;
  color: #4E243F;

  .knd-modal-container {
    padding: 2em;
  }

  .knd-modal-title {
    color: #00DEB2;
  }
}
.close {
  text-align: center;
  margin: 10% 0 0 16px;
  cursor: pointer;
}

</style>